import React from "react";
//import components
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import PoolsTable from "./PoolsTable";
import { useTranslation } from "react-i18next";

export default function PoolsList() {
  const { t } = useTranslation();
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Pools")} />
        <PoolsTable />
      </div>
    </div>
  );
}
